import React, { useCallback, useState } from "react";

import Loader from "Components/Loader/Loader";

const useFullPageLoader = () => {
  const [loading, setLoading] = useState(false);
  const showLoader = useCallback(() => setLoading(true), []);
  const hideLoader = useCallback(() => setLoading(false), []);

  return [
    loading ? <Loader /> : null,
    showLoader,
    hideLoader,
  ];
};

export default useFullPageLoader;
